export const LOGIN_PAGE_ROUTE = "/login";